import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledErrorData = styled(Box, {
  alignItems: 'center',
  border: '1px solid $seafoam400',
  borderRadius: '$4',
  color: '$darkBlue400',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$xl',
  fontWeight: '$bold',
  height: '100%',
  justifyContent: 'center',
  lineHeight: '$8',
  margin: 'auto',
  minHeight: '150px',
  padding: 0,
});

export const StyledMessage = styled(Box, {
  marginBottom: '$2',
  width: '20%',
});

export const StyledContact = styled(Box, {
  fontSize: '$lg',
  fontWeight: '$regular',
});
